import { SET_PAGE_INFO, SET_SITE_SETTINGS } from './types';
import api from "../utils/api";

export const send = (settings) => dispatch => {
  dispatch({
    type: SET_PAGE_INFO,
    payload: settings
  });
};

export const settings = () => async(dispatch) => {
  const result = await api.get(`/utility/settings?h=${window.location.host}`);
  dispatch({
    type: SET_SITE_SETTINGS,
    payload: result?.data
  });

  return result?.data;
}